<template>
  <vbt-content-box v-bind="$attrs">
    <template #title>
      <v-layout align-center>
        <strong class="green--text">
          #{{ $route.params.id }}
        </strong>
        <kernel-status-badge
          v-show="!$attrs.loading"
          :status="orderStatusEnumByValue[order.status]"
          class="mx-2"
        >
          Status:
          <strong>
            {{ order.status }}
          </strong>
        </kernel-status-badge>
        <kernel-status-badge
          v-show="!$attrs.loading"
          :status="validationStatusEnumByValue[order.validationStatus]"
        >
          Validation Status:
          <strong>
            {{ order.validationStatus }}
          </strong>
        </kernel-status-badge>
      </v-layout>
    </template>
    <v-layout
      :class="$_themeTextColorClass"
      class="mt-2"
    >
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Create date:
          </strong>
          {{ formatDate(order.created) }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Delivery date:
          </strong>
          {{ formatDate(order.deliveryDate) }}
        </v-layout>
        <v-layout class="warning--text">
          <strong class="mr-1 vbt-strong-label">
            Expires date:
          </strong>
          {{ formatDate(order.expires) }}
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Customer ID:
          </strong>
          {{ order.customerId }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Print customer:
          </strong>
          {{ order.printCustomer }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Contract type:
          </strong>
          {{ additional.contract }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Shipping method:
          </strong>
          {{ additional.shipMethod || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Shipping signature:
          </strong>
          {{ additional.shipSignature || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Shipping vendor:
          </strong>
          {{ additional.shipVendor || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Shipping fee:
          </strong>
          {{ order.shippingFee || '-' }}
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Delivery address:
          </strong>
          {{ deliveryAddress || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Contact name:
          </strong>
          {{ contact.attention || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Attention:
          </strong>
          {{ contact.attention || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Company:
          </strong>
          {{ contact.company || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Email:
          </strong>
          {{ contact.email || '-' }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Phone:
          </strong>
          {{ contact.phone || '-' }}
        </v-layout>
      </v-flex>
    </v-layout>
  </vbt-content-box>
</template>

<script>
import { mapGetters } from 'vuex';

import { formatDate } from '@helpers';

import { provideThemeSettings } from '@mixins';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';

export default {
  name: 'KernelOrderInfoView',
  mixins: [
    provideThemeSettings,
  ],
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(EnumsNamespace, ['orderStatusEnumByValue', 'validationStatusEnumByValue']),
    additional() {
      return this.order.additional || {};
    },
    contact() {
      return this.order?.deliveryAddress?.contact || {};
    },
    deliveryAddress() {
      const { deliveryAddress: addr = {} } = this.order;
      return [
        'streetLine1',
        'streetLine2',
        'streetLine3',
        'city',
        'state',
        'zip',
        'country',
      ]
        .filter((s) => Boolean(addr[s]))
        .map((s) => addr[s])
        .join(', ');
    },
  },
  methods: {
    formatDate,
  },
};
</script>
